module.exports = __webpack_public_path__ + "static/img/matanza-digital-2.a656378.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/matanza-digital-2.jpg
// module id = 84Uq
// module chunks = 1